import { currentDevice } from '../../core/utils/currentDevice'
import { getIsUserScrolling } from '../../core/utils/userScrollDetection'
import { sendFastbookingHeadbandUtagEvent } from '../../elements/headband/headband.analytics'
import MainHeader from '../../layout/header/header'
import { currentPageType } from '../../utils/page_type_detector'
import { isHeaderSticky } from '../../utils/utilities'
import { hideHeaderStickyHotel } from '../header_sticky_hotel/header_sticky_hotel'

import { IBH_FASTBOOKING_EVENTS } from './constants'
import fastbooking from './ibh_fastbooking'

function handleHeadbandFastbooking(headerIsSticky) {
  const isUserScrolling = getIsUserScrolling()
  const isHotelOrBooking = currentPageType.isHotel() || currentPageType.isBookings()

  sendFastbookingHeadbandUtagEvent('headband', headerIsSticky ? 'sticky' : 'header')

  if (headerIsSticky) {
    if (!currentDevice.isMobile) {
      MainHeader.openPanel()
    }
    if (isHotelOrBooking) {
      fastbooking.openDates()
    } else {
      fastbooking.openDestination()
    }
  } else if (isHotelOrBooking) {
    fastbooking.openDates()
    document.dispatchEvent(new CustomEvent(IBH_FASTBOOKING_EVENTS.OPEN_STICKY_FASTBOOKING))
  } else {
    fastbooking.openDestination()
    if (isUserScrolling) {
      fastbooking.closePanels()
    }
  }
}

function handleDefaultFastbooking(headerIsSticky) {
  if (headerIsSticky || currentPageType.isSpecialty()) {
    if (!currentDevice.isMobile) {
      MainHeader.openPanel()
    }
    fastbooking.openDates()
  } else {
    if (!currentPageType.isHome()) {
      hideHeaderStickyHotel()
      fastbooking.openStickyFastbooking()
    }
    fastbooking.openDates()
  }
}
export function initOpenFastbookingDelegation() {
  document.body.addEventListener('click', e => {
    const button = e.target.closest('.js-open-fastbooking')

    if (!button) return

    e.preventDefault()
    const headerIsSticky = isHeaderSticky()
    const isFromHeadband = button.closest('.js-headband')

    if (isFromHeadband) {
      handleHeadbandFastbooking(headerIsSticky)
    } else {
      handleDefaultFastbooking(headerIsSticky)
    }
  })
}
initOpenFastbookingDelegation()
